import {useState, useEffect} from 'react'   
import {FaUser} from 'react-icons/fa'
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'  
import {toast} from 'react-toastify' 

import {register, reset} from '../features/auth/authSlice'

import Spinner from '../components/Spinner'   

function Register() {
  const [formData, setFormData] = useState({  
    name: '',
    email: '',
    password: '',
    password2: ''
  })

  const {name, email, password, password2} = formData   

  const navigate = useNavigate();   
  const dispatch = useDispatch();

  const {user, isLoading, isError, isSuccess, message} = useSelector((state) => state.auth)
  

  useEffect(() => {
    if (isError) {
      toast.error(message)
    }
    if (isSuccess || user) {  
      navigate('/')
     

      dispatch(reset());  
    }
  }, [user, isError, isSuccess, message, navigate, dispatch])
  


  const onChange = (e) => {
    setFormData((prevState) => ({       
      ...prevState,                     
      [e.target.name]: e.target.value,  
    }))
  }

  const onSubmit = (e) => {
    e.preventDefault();

    if (password !== password2) {
      toast.error('Passwords do not match') 
    } else {
     
      const userData = {      
        name, email, password
      } 

      dispatch(register(userData))    
    }
  }
  if (isLoading) {
    return <Spinner/>   
  }

  return <>
    <section className='heading'>
      <h1>
        <FaUser /> Register      {/* FaUser is the cute little user icon imported from react-icons */}       
      </h1>
    </section>

    <section className='form'>
      <form onSubmit={onSubmit}>
        {/* created with .form--group. Putting this stuff in 'form-group' prettifies the text box. This will be copied 4 times below */}
        <div className="form-group">
          {/* created with input.form--control, and the id onward manually added. "value={name}" comes from destructuring*/}
          <input 
          type="text" 
          className="form-control" 
          id='name' 
          name='name' 
          value={name} 
          placeholder='Enter your name' 
          onChange={onChange}/>     
        </div>  

        {/* this one for the email */}
        <div className="form-group">
          <input 
          type="email" 
          className="form-control" 
          id='email' 
          name='email' 
          value={email} 
          placeholder='Enter your email' 
          onChange={onChange}/>     
        </div>

        {/* this one for password */}
        <div className="form-group">
          <input 
          type="password" 
          className="form-control" 
          id='password' 
          name='password' 
          value={password} 
          placeholder='Enter password' 
          onChange={onChange}/>     
        </div>     

        {/* this one for reentered password */}
        <div className="form-group">
          <input 
          type="password2" 
          className="form-control" 
          id='password2' 
          name='password2' 
          value={password2} 
          placeholder='Confirm password' 
          onChange={onChange}/>     
        </div>  
        
        {/* created with .form-group */}
        <div className="form-group">
          {/* created with button:submit */}
          <button type="submit" className='btn btn-block'>
            Submit
          </button>
        </div>

      </form>

    </section>


  </>
}

export default Register